import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"url(#success_svg__a)\" d=\"M0 8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v32a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"></path><path fill=\"currentColor\" d=\"M24 14c5.52 0 10 4.48 10 10s-4.48 10-10 10-10-4.48-10-10 4.48-10 10-10m5.3 6.29c-.39-.39-1.03-.39-1.42 0L22 26.17l-1.88-1.88a.996.996 0 1 0-1.41 1.41l2.59 2.59a.996.996 0 0 0 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41\"></path><defs><linearGradient id=\"success_svg__a\" x1=\"2.571\" x2=\"48\" y1=\"2.571\" y2=\"48\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#1F8641\" stop-opacity=\".64\"></stop><stop offset=\"1\" stop-color=\"#1F8641\" stop-opacity=\".08\"></stop></linearGradient></defs>", 3)
  ]))]))
}
export default { render: render }